import { useState } from "react";
import { calendarService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { ICalendar } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getCalendarUUID = createUUID();

export const useCalendar = () => {
  const [calendar, setCalendar] = useState<ICalendar | null>(null);
  const stateManager = useComponentState();

  const getCalendar = (id: string) => {
    stateManager.abort(getCalendarUUID);
    stateManager.run(async () => {
      const response = await calendarService.calendars.getById({
        id,
      });

      if (response.status === HTTP_STATUSES.OK) {
        setCalendar(response.data);
      }
    }, getCalendarUUID);
  };

  return {
    loading: stateManager.isBusy(),
    calendar,
    getCalendar,
  };
};
